import React from 'react';
import Image from 'next/image';
import { Fade } from 'react-awesome-reveal';
import styles from './books.module.scss';
import { Button } from '../Button';
import { Typography } from '../Typography';
import { getProductSlugById } from '../../data/products';

const Books = ({ products }: any): any => {
  const product = products[0];

  const handleLearnMore = () => {
    const slug = getProductSlugById(product._id) || product.product_name.toLowerCase();
    window.open(`/video-plugin-framework/${slug}`, '_blank');
  };

  const handleFreeTrial = () => {
    const slug = getProductSlugById(product._id) || product.product_name.toLowerCase();
    window.open(`/video-plugin-framework/${slug}?scroll=more`, '_blank');
  };

  const features = [
    {
      id: 1,
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11 4.5H18.3C19.4201 4.5 19.9802 4.5 20.408 4.71799C20.7843 4.90973 21.0903 5.21569 21.282 5.59202C21.5 6.01984 21.5 6.57989 21.5 7.7V9C21.5 9.93188 21.5 10.3978 21.3478 10.7654C21.1448 11.2554 20.7554 11.6448 20.2654 11.8478C19.8978 12 19.4319 12 18.5 12M13 19.5H5.7C4.5799 19.5 4.01984 19.5 3.59202 19.282C3.21569 19.0903 2.90973 18.7843 2.71799 18.408C2.5 17.9802 2.5 17.4201 2.5 16.3V15C2.5 14.0681 2.5 13.6022 2.65224 13.2346C2.85523 12.7446 3.24458 12.3552 3.73463 12.1522C4.10218 12 4.56812 12 5.5 12M10.3 14.5H13.7C13.98 14.5 14.12 14.5 14.227 14.4455C14.3211 14.3976 14.3976 14.3211 14.4455 14.227C14.5 14.12 14.5 13.98 14.5 13.7V10.3C14.5 10.02 14.5 9.87996 14.4455 9.773C14.3976 9.67892 14.3211 9.60243 14.227 9.5545C14.12 9.5 13.98 9.5 13.7 9.5H10.3C10.02 9.5 9.87996 9.5 9.773 9.5545C9.67892 9.60243 9.60243 9.67892 9.5545 9.773C9.5 9.87996 9.5 10.02 9.5 10.3V13.7C9.5 13.98 9.5 14.12 9.5545 14.227C9.60243 14.3211 9.67892 14.3976 9.773 14.4455C9.87996 14.5 10.02 14.5 10.3 14.5ZM17.8 22H21.2C21.48 22 21.62 22 21.727 21.9455C21.8211 21.8976 21.8976 21.8211 21.9455 21.727C22 21.62 22 21.48 22 21.2V17.8C22 17.52 22 17.38 21.9455 17.273C21.8976 17.1789 21.8211 17.1024 21.727 17.0545C21.62 17 21.48 17 21.2 17H17.8C17.52 17 17.38 17 17.273 17.0545C17.1789 17.1024 17.1024 17.1789 17.0545 17.273C17 17.38 17 17.52 17 17.8V21.2C17 21.48 17 21.62 17.0545 21.727C17.1024 21.8211 17.1789 21.8976 17.273 21.9455C17.38 22 17.52 22 17.8 22ZM2.8 7H6.2C6.48003 7 6.62004 7 6.727 6.9455C6.82108 6.89757 6.89757 6.82108 6.9455 6.727C7 6.62004 7 6.48003 7 6.2V2.8C7 2.51997 7 2.37996 6.9455 2.273C6.89757 2.17892 6.82108 2.10243 6.727 2.0545C6.62004 2 6.48003 2 6.2 2H2.8C2.51997 2 2.37996 2 2.273 2.0545C2.17892 2.10243 2.10243 2.17892 2.0545 2.273C2 2.37996 2 2.51997 2 2.8V6.2C2 6.48003 2 6.62004 2.0545 6.727C2.10243 6.82108 2.17892 6.89757 2.273 6.9455C2.37996 7 2.51997 7 2.8 7Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      title: 'Visual Graph Editor',
      description:
        'Design complex processing pipelines with our intuitive node-based editor. Connect, configure, and preview in real-time.',
    },
    {
      id: 2,
      icon: (
        <svg
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8 1V3M14 1V3M8 19V21M14 19V21M19 8H21M19 13H21M1 8H3M1 13H3M7.8 19H14.2C15.8802 19 16.7202 19 17.362 18.673C17.9265 18.3854 18.3854 17.9265 18.673 17.362C19 16.7202 19 15.8802 19 14.2V7.8C19 6.11984 19 5.27976 18.673 4.63803C18.3854 4.07354 17.9265 3.6146 17.362 3.32698C16.7202 3 15.8802 3 14.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V14.2C3 15.8802 3 16.7202 3.32698 17.362C3.6146 17.9265 4.07354 18.3854 4.63803 18.673C5.27976 19 6.11984 19 7.8 19ZM9.6 14H12.4C12.9601 14 13.2401 14 13.454 13.891C13.6422 13.7951 13.7951 13.6422 13.891 13.454C14 13.2401 14 12.9601 14 12.4V9.6C14 9.03995 14 8.75992 13.891 8.54601C13.7951 8.35785 13.6422 8.20487 13.454 8.10899C13.2401 8 12.9601 8 12.4 8H9.6C9.03995 8 8.75992 8 8.54601 8.10899C8.35785 8.20487 8.20487 8.35785 8.10899 8.54601C8 8.75992 8 9.03995 8 9.6V12.4C8 12.9601 8 13.2401 8.10899 13.454C8.20487 13.6422 8.35785 13.7951 8.54601 13.891C8.75992 14 9.03995 14 9.6 14Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      title: 'Multi-GPU Support',
      description:
        'Write kernels once for CUDA, Metal, and OpenCL. We handle the optimization and deployment across all platforms.',
    },
    {
      id: 3,
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 15L15 12L12 9M8 5L5 8L8 11M5.8 19H14.2C15.8802 19 16.7202 19 17.362 18.673C17.9265 18.3854 18.3854 17.9265 18.673 17.362C19 16.7202 19 15.8802 19 14.2V5.8C19 4.11984 19 3.27976 18.673 2.63803C18.3854 2.07354 17.9265 1.6146 17.362 1.32698C16.7202 1 15.8802 1 14.2 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V14.2C1 15.8802 1 16.7202 1.32698 17.362C1.6146 17.9265 2.07354 18.3854 2.63803 18.673C3.27976 19 4.11984 19 5.8 19Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      title: 'Native SDK Integration',
      description:
        'Seamlessly integrates with OpenFX, Adobe SDK, FxPlug, and more. Your plugins feel native in every host.',
    },
  ];

  const benefits = [
    {
      id: 1,
      title: 'Seamless Integration',
    },
    {
      id: 2,
      title: 'Modular Kernal System',
    },
    {
      id: 3,
      title: 'Back-End Agnostics',
    },
    {
      id: 4,
      title: 'Cross-Platform Compatibility',
    },
    {
      id: 5,
      title: 'Pre-Built Effect Library',
    },
  ];

  return (
    <div id="product" className={styles.booksSection}>
      <div className={styles.mainContainer}>
        {/* Single Main Card */}
        <div className={styles.mainCard}>
          {/* Left Side - Image Only */}
          <div className={styles.imageContainer}>
            <Image
              src="/product-book-cover.jpg"
              alt="VxFX Universal Video Plugin Development Framework - Build Once, Deploy Everywhere"
              layout="fill"
              objectFit="cover"
              priority
            />
          </div>

          {/* Right Side - All Content */}
          <Fade triggerOnce duration={800} delay={400}>
            <div className={styles.contentContainer}>
              {/* Header */}
              <div className={styles.header}>
                <div className={styles.badge}>
                  <img
                    src="/vxfx-app-name-book.svg"
                    alt="VxFX Video Plugin Development Framework Logo"
                  />
                </div>

                <Typography
                  variant="text-md"
                  as="h2"
                  color="grayDark-50"
                  weight="bold"
                  align="center"
                >
                  The Universal Video Plugin Development Framework.
                </Typography>

                <Typography
                  variant="text-sm"
                  as="p"
                  color="grayDark-50"
                  weight="normal"
                  align="center"
                >
                  Build Once, Deploy Everywhere.
                </Typography>
              </div>

              <div className={styles.boxesContainer}>
                {/* Support Box */}
                <div className={styles.compatibleWithBox}>
                  <Typography
                    variant="text-sm"
                    color="primary"
                    className={styles.compatibleWithTitle}
                  >
                    Support
                  </Typography>
                  <div className={styles.compatibleWithGrid}>
                    {[...(product?.target_applications || [])].map((app: string, index: number) => {
                      let iconSrc = '';
                      switch (app) {
                        case 'DaVinci Resolve':
                          iconSrc = '/logo/DaVinci_Resolve_Studio.svg';
                          break;
                        case 'Adobe Premiere Pro':
                          iconSrc = '/logo/Adobe_Premiere_Pro.svg';
                          break;
                        case 'Sony VEGAS Pro':
                          iconSrc = '/logo/Vegas_Pro.svg';
                          break;
                        case 'FinalCut':
                          iconSrc = '/logo/Final_Cut_Pro.svg';
                          break;
                        case 'Natron':
                          iconSrc = '/logo/Natron.svg';
                          break;
                        case 'Nuke':
                          iconSrc = '/logo/Nuke.svg';
                          break;
                        case 'Apple Motion':
                          iconSrc = '/logo/Apple_Motion.svg';
                          break;
                        case 'NVIDIA CUDA':
                          iconSrc = '/logo/NVIDIA_CUDA.svg';
                          break;
                        case 'Apple Metal':
                          iconSrc = '/logo/Apple_Metal.svg';
                          break;
                        case 'OpenCL':
                          iconSrc = '/logo/OpenCL.svg';
                          break;
                        case 'CPU':
                          iconSrc = '/logo/cpu.png';
                          break;
                        default:
                          iconSrc = '';
                      }

                      return iconSrc ? (
                        <div key={index} className={styles.compatibleItem}>
                          <img src={iconSrc} alt={`${app} - Compatible Video Editing Platform`} />
                        </div>
                      ) : null;
                    })}
                  </div>
                </div>

                {/* Compatible With Box */}
                <div className={styles.compatibleWithBox}>
                  <Typography
                    variant="text-sm"
                    color="primary"
                    className={styles.compatibleWithTitle}
                  >
                    Compatible With
                  </Typography>
                  <div className={styles.compatibleWithGrid}>
                    {[...(product?.supported_gpu_architectures || [])].map(
                      (app: string, index: number) => {
                        let iconSrc = '';
                        switch (app) {
                          case 'DaVinci Resolve':
                            iconSrc = '/logo/DaVinci_Resolve_Studio.svg';
                            break;
                          case 'Adobe Premiere Pro':
                            iconSrc = '/logo/Adobe_Premiere_Pro.svg';
                            break;
                          case 'Sony VEGAS Pro':
                            iconSrc = '/logo/Vegas_Pro.svg';
                            break;
                          case 'FinalCut':
                            iconSrc = '/logo/Final_Cut_Pro.svg';
                            break;
                          case 'Natron':
                            iconSrc = '/logo/Natron.svg';
                            break;
                          case 'Nuke':
                            iconSrc = '/logo/Nuke.svg';
                            break;
                          case 'Apple Motion':
                            iconSrc = '/logo/Apple_Motion.svg';
                            break;
                          case 'NVIDIA CUDA':
                            iconSrc = '/logo/NVIDIA_CUDA.svg';
                            break;
                          case 'Apple Metal':
                            iconSrc = '/logo/Apple_Metal.svg';
                            break;
                          case 'OpenCL':
                            iconSrc = '/logo/OpenCL.svg';
                            break;
                          case 'CPU':
                            iconSrc = '/logo/cpu.png';
                            break;
                          default:
                            iconSrc = '';
                        }

                        let title = '';
                        switch (app) {
                          case 'NVIDIA CUDA':
                            title = 'NVIDIA';
                            break;
                          case 'Apple Metal':
                            title = 'Apple Metal';
                            break;
                          case 'OpenCL':
                            title = 'Open CL';
                            break;
                          case 'CPU':
                            title = 'CPU';
                            break;
                          default:
                            title = '';
                        }

                        return iconSrc ? (
                          <div key={`platform-${index}`} className={styles.availableOnItem}>
                            <div key={index} className={styles.compatibleItem}>
                              <img
                                src={iconSrc}
                                alt={`${app} - Compatible Video Editing Platform`}
                              />
                            </div>
                            <Typography
                              variant="text-xs"
                              as="span"
                              weight="light"
                              color="grayDark-200"
                              style={{ textAlign: 'center' }}
                            >
                              {title}
                            </Typography>
                          </div>
                        ) : null;
                      }
                    )}
                  </div>
                </div>

                {/* Available On Box */}
                <div className={styles.availableOnBox}>
                  <Typography
                    variant="text-sm"
                    color="primary"
                    className={styles.availableOnBoxTitle}
                  >
                    Available On
                  </Typography>
                  <div className={styles.availableOnGrid}>
                    {(product?.supported_platforms || []).map((platform: string, index: number) => {
                      let iconSrc = '';
                      switch (platform) {
                        case 'Windows':
                          iconSrc = '/logo/Windows.svg';
                          break;
                        case 'MacOS':
                          iconSrc = '/logo/macOS.svg';
                          break;
                        case 'Linux':
                          iconSrc = '/logo/Linux.svg';
                          break;
                        default:
                          iconSrc = '';
                      }

                      let title = '';
                      switch (platform) {
                        case 'Windows':
                          title = 'Windows';
                          break;
                        case 'MacOS':
                          title = 'MacOS';
                          break;
                        case 'Linux':
                          title = 'Linux';
                          break;
                        default:
                          title = '';
                      }

                      return iconSrc ? (
                        <div key={`platform-${index}`} className={styles.availableOnItem}>
                          <div className={styles.availableOnIcon}>
                            <img
                              src={iconSrc}
                              alt={`${platform} - Supported Operating System Platform`}
                            />
                          </div>
                          <Typography
                            variant="text-xs"
                            as="span"
                            weight="light"
                            color="grayDark-200"
                            style={{ textAlign: 'center' }}
                          >
                            {title}
                          </Typography>
                        </div>
                      ) : null;
                    })}
                  </div>
                </div>
              </div>

              {/* Description */}
              <Typography
                variant="text-lg"
                as="p"
                color="primary"
                className={styles.description}
                weight="normal"
              >
                Design, compile, and deploy professional video processing plugins across all major
                editing platforms with a single visual workflow.
              </Typography>

              {/* Key Features */}
              <div className={styles.featuresSection}>
                {features.map((feature: any) => (
                  <div key={feature.id} className={styles.featureCard}>
                    <div className={styles.featureIcon}>{feature.icon}</div>
                    <Typography variant="text-sm" as="h3" color="primary" weight="bold">
                      {feature.title}
                    </Typography>
                    <Typography
                      variant="text-xs"
                      as="p"
                      color="secondary"
                      weight="normal"
                      style={{ color: '#CBD5E1' }}
                    >
                      {feature.description}
                    </Typography>
                  </div>
                ))}
              </div>

              {/* Benefits List */}
              <div className={styles.benefitsSection}>
                <div className={styles.benefitsList}>
                  {benefits.map((benefit: any) => (
                    <div key={benefit.id} className={styles.benefitItem}>
                      <div className={styles.checkIcon}>
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z"
                            fill="#6A2DC7"
                          />
                          <path
                            d="M5 8L7 10L11 6"
                            stroke="white"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <Typography variant="text-xs" color="primary" weight="normal">
                        {benefit.title}
                      </Typography>
                    </div>
                  ))}
                </div>
              </div>

              {/* CTA Buttons */}
              <div className={styles.ctaSection}>
                <Button variant="secondary" fullWidth onClick={handleLearnMore}>
                  Learn More
                </Button>

                <Button variant="warning" fullWidth onClick={handleFreeTrial}>
                  Buy Now
                </Button>
              </div>
            </div>
          </Fade>
        </div>
      </div>
    </div>
  );
};

export default Books;
